/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react component to get date
import ReactDatetime from "react-datetime";
// reactstrap components
import {
  Button,
  Modal,
  ModalBody,
  FormGroup,
  Input
} from "reactstrap";
//redux components
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// actions
import { 
  fetchVersionOperation
} from "../../actions/model_actions";
import { isObjEmpty } from "../../utils/utils";

class VersionRegisterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        version_name: "",
        version_nameState: "",
        userFullNameState: "",
        version_date: "",
        version_dateState: "",
        keyList: [],
        key_text: "",
        value_text: "",
        dateFormat: null,
        version_performance_metrics: {}
    };
  }

  componentDidMount() {
    const {  } = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;
  }

  verifyEmail = value => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };
  // function that verifies if a string has a given length or not
  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  verifyUserId = value => {
    this.setState({userId_isValidated: false})
    var emailRex = /^([a-z]+[0-9]*)+(-[a-z]+[0-9]*)*$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  change = (event, stateName, type, stateNameEqualTo) => {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "length":
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "userId":
        if (this.verifyUserId(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger"});
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  };

  getTodayDate = (ev) => {
    let dateToday = new Date();
    // console.log(dateToday.toISOString().split('T')[0])
    let day = dateToday.getDate()
    let month = dateToday.getMonth() + 1
    let year = dateToday.getFullYear()
    this.setState({
      version_date: month < 10 && day < 10 ? `0${day}-0${month}-${year}` : 
      month < 10 && day >= 10 ? `${day}-0${month}-${year}` : 
      month >= 10 && day < 10 ? `0${day}-${month}-${year}` : 
      `${day}-${month}-${year}`, 
      dateFormat: dateToday.toISOString().split('T')[0]});
  }

  handleVersionDate = (ev) => {
    this.setState({version_date: ev.format("DD-MM-YYYY"), dateFormat: ev.format("YYYY-MM-DD")})
  };

  handleKeysVersions = () => {
    const { keyList, key_text, value_text, version_performance_metrics } = this.state;
    let aux = [...keyList, keyList.length + 1]
    if(keyList.length !== 0) {
      let metricsAux = Object.assign(version_performance_metrics, {[key_text]: value_text})
      this.setState({keyList: aux, key_text: "", value_text: "", version_performance_metrics: metricsAux})
    } else {
      this.setState({keyList: aux})
    }
  }

  setkey = (ev) => {
    this.setState({key_text: ev.target.value})
  }

  setValue = (ev) => {
    this.setState({value_text: ev.target.value})
  }

  toggleModalVersionAdd = () => {
    const { fetchVersionOperation, userView, showModelAddVersion } = this.props;
    const { version_name, version_date, version_performance_metrics, key_text, value_text } = this.state;
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    let metricsObject = {};
    if(key_text !== "" || (key_text !== "" && value_text !== "")) {
      metricsObject = Object.assign(version_performance_metrics, {[key_text]: value_text});
    }
    if(!isObjEmpty(metricsObject)) {
      for(let key in metricsObject) {
        if(metricsObject[key] === "") {
          delete metricsObject[key]
        }
      } 
    }
    // console.log(metricsObject);
    let userVersionsObj = {
      token: idToken,
      client_id: userView._id,
      model_id: showModelAddVersion.model_id,
      operation: "append",
      pop_version_name: null,
      new_version: {
        version_name: version_name,
        version_date: version_date,
        version_performance_metrics: metricsObject
      }
    }
    console.log(userVersionsObj)
    fetchVersionOperation(userVersionsObj)
    this.setState({
      version_name: "",
      version_date: "",
      version_performance_metrics: {},
      showModelAddVersion: {},
      showVersion: !this.state.showVersion,
      key_text: "",
      value_text: "",
      version_performance_metrics: {},
      keyList: []
    })
    this.props.handleModalVersionModel();
  }

  render() {
    const { 
        userFullNameState, 
        version_nameState,
        version_name,
        version_date,
        dateFormat
    } = this.state;
    const { showVersion, handleModalVersionModel } = this.props;
    // console.log(user);
    return (
      <>
        <Modal
            isOpen={showVersion}
            toggle={handleModalVersionModel}
        >
            <div className="modal-header" style={{justifyContent: 'center'}}>
                <h4 className="title title-up">
                    Add Version
                </h4>
            </div>
            <ModalBody>
                <FormGroup className={`has-label ${version_nameState}`}>
                    <label>Version Name *</label>
                    <Input
                        name="version_name"
                        type="text"
                        onChange={e =>
                            this.change(e, "version_name", "length", 1)
                        }
                        style={{color: "#000"}}
                    />
                    {version_nameState === "has-danger" ? (
                        <label className="error">This field is required.</label>
                    ) : null}
                </FormGroup>
                <div style={{textAlign: "center"}}>
                    <FormGroup className={`has-label ${userFullNameState}`} style={{display: "inline-block", minWidth: "300px"}}>
                        <label style={{float: "left"}}>Version Date *</label>
                        <ReactDatetime
                            inputProps={{
                            className: "form-control text-calendar",
                            placeholder: "Select Date Here",
                            }}
                            timeFormat={false}
                            onChange={this.handleVersionDate}
                            value={dateFormat}
                        />
                    </FormGroup>
                    <Button
                        color="default"
                        style={{marginLeft: "25px"}}
                        type="button"
                        onClick={this.getTodayDate}
                    >
                        Today
                    </Button>
                </div>
                <FormGroup className={`has-label `}>
                    <label>Version Performance Metrics</label>
                    <Button className="like btn-neutral" color="primary" onClick={this.handleKeysVersions}>
                        Add Metric
                    </Button>
                    {this.state.keyList && this.state.keyList.map((val, index) => {
                        return (
                            <div style= {{display: "flex", marginBottom: "3px"}} key={index}>
                                <Input
                                    name="key"
                                    type="text"
                                    onChange={this.setkey}
                                    style={{color: "#000", background: "#fff", marginRight: "5px"}}
                                    bsSize="sm"
                                    placeholder="Key"
                                    id={index}
                                />
                                <Input
                                    name="value"
                                    type="text"
                                    onChange={this.setValue}
                                    style={{color: "#000", background: "#fff"}}
                                    bsSize="sm"
                                    placeholder="Value"
                                    id={index}
                                />
                            </div>
                        )
                    })}
                </FormGroup>
            </ModalBody>
            <div className="modal-footer justify-content-center">
                <Button
                    className="btn-round"
                    color="info"
                    data-dismiss="modal"
                    type="button"
                    onClick={this.toggleModalVersionAdd}
                    disabled={version_nameState === "has-danger" ||
                                version_name === "" ||
                                version_date === "" ? true : false}
                >
                Create New Version
                </Button>
            </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchVersionOperation }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(VersionRegisterModal);